type Bounds = Pick<DOMRect, 'left' | 'top' | 'width' | 'height'>;

/** Use the rendered card, including the wall's scale and current row position. */
export function getHeroExpansion(stage: Bounds, cards: Bounds[]) {
  if (stage.width <= 0 || stage.height <= 0) return null;

  const centerX = stage.left + stage.width / 2;
  const centerY = stage.top + stage.height / 2;
  const source = cards.filter((card) => card.width > 0 && card.height > 0)
    .reduce<Bounds | null>((closest, card) => {
      const distance = (bounds: Bounds) => Math.hypot(
        bounds.left + bounds.width / 2 - centerX,
        bounds.top + bounds.height / 2 - centerY,
      );
      return !closest || distance(card) < distance(closest) ? card : closest;
    }, null);
  if (!source) return null;

  const radius = source.width * 0.065;
  return {
    left: source.left - stage.left,
    top: source.top - stage.top,
    width: source.width,
    height: source.height,
    radius,
    translateX: centerX - source.left - source.width / 2,
    translateY: centerY - source.top - source.height / 2,
    // Cover with the card's inner rectangle so even its rounded corners leave
    // the viewport. Scale uniformly rather than stretching the pass into a box.
    scale: Math.max(
      (stage.width + 4) / (source.width - 2 * radius),
      (stage.height + 4) / (source.height - 2 * radius),
    ),
  };
}
